import React, { useState, useEffect } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import { initStorage, loadCFG, initFirebase } from "./core/platform.js";
import { App } from "./views/AppShell.jsx";
import { AcademyApp } from "./views/Academy.jsx";
import { VizDemo } from "./views/VizDemo.jsx";
import { BetaApply } from "./views/Beta.jsx";

// 진입로 5갈래: 기본=범용(무엇이든 넣어 공부) · #student=한국 중고등 수학 학생용 · #us=미국 수학 학생용 · #academy=학원용 · #beta=베타테스터 신청
// + 개발용: #vizdemo(벡터 렌더러)·#geodemo(기하 상호작용) — student(/math/) 검사보다 먼저 봐야 함
// 베타 신청만 경로(/beta)로도 연다 — 문자·포스터에 "#"이 든 주소를 적으면 잘리거나 오타가 나서
// 유입이 샌다. Vercel 쪽 rewrite(vercel.json)가 /beta에 index.html을 내려주고 여기서 화면을 고른다.
// 해시가 없을 때만 경로를 본다 — 신청 완료 후 Beta.jsx가 location.hash="#student"로 넘기는데,
// 경로(/beta)를 무조건 우선하면 해시를 바꿔도 계속 신청 화면에 갇힌다.
const _isBetaPath=()=>!location.hash&&/^\/beta\/?$/i.test(location.pathname||"");
function route(){
  if(/vizdemo|geodemo/i.test(location.hash))return "vizdemo";
  if(/beta/i.test(location.hash)||_isBetaPath())return "beta";
  if(/academy/i.test(location.hash))return "academy";
  if(/^#us\b/i.test(location.hash))return "us";
  if(/student|math/i.test(location.hash))return "student";
  return "general";
}
function Root(){
  const [mode,setMode]=useState(route());
  useEffect(()=>{const f=()=>setMode(route());window.addEventListener("hashchange",f);return ()=>window.removeEventListener("hashchange",f);},[]);
  if(mode==="vizdemo")return <VizDemo/>;
  if(mode==="beta")return <BetaApply/>;
  if(mode==="academy")return <div className="academy-skin"><AcademyApp/></div>;
  return <App key={mode} edition={mode}/>;
}

function boot(){
  loadCFG();initFirebase();
  createRoot(document.getElementById("root")).render(<Root/>);
}
initStorage().then(boot).catch(e=>{console.error("[boot]",e);boot();});
